import { gql } from "@apollo/client";

export const ACTIVATE_DEACTIVATE_USER = gql`
  mutation ActivateDeactivateUser($userId: ID!) {
    activateDeactivateUser(userId: $userId) {
      _id
      name
      email
      role
      active
    }
  }
`;